import { gql, useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { captureException } from "@sentry/react";

import { AUTH_ID, AUTH_TOKEN, AUTH_WS_TOKEN, SHARD_NUMBER } from "constants";
import LoadingPage from "components/other/LoadingPage";

export default () => {
  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");
  const destination = searchParams.get("destination");

  if (!code) {
    window.location = "/?message=magicLoginFailed";
    return;
  }

  const SUPER_LOGIN = gql`
    mutation SuperLogin($code: String!) {
      superLogin(code: $code) {
        resultCode
        id
        token
        wsToken
        shardNumber
      }
    }
  `;

  const [superLogin] = useMutation(SUPER_LOGIN);

  const processLogin = async () => {
    try {
      const result = await superLogin({
        variables: { code },
      });

      const { resultCode, id, token, wsToken, shardNumber } =
        result.data.superLogin;

      if (resultCode !== 0 || !token) {
        window.location = "/?message=magicLoginFailed";
        return;
      }

      // login successfull, redirect to account
      localStorage.setItem(AUTH_ID, id);
      localStorage.setItem(AUTH_TOKEN, token);
      localStorage.setItem(AUTH_WS_TOKEN, wsToken);
      localStorage.setItem(SHARD_NUMBER, shardNumber);

      if (destination && destination !== "")
        window.location = "/" + destination;
      else window.location = "/home";
    } catch (error) {
      captureException(error);
      console.log("superLogin error", error);
      return;
    }
  };

  useEffect(() => {
    processLogin();
  }, []);

  return <LoadingPage />;
};
